<div class="navbar-nav bd-navbar-nav px-3">
  <a
    class="nav-link"
    data-bs-toggle="dropdown"
    [attr.aria-expanded]="showMessages"
    [ngClass]="{ show: showMessages, 'text-warning': messages.length > 0 }">
    {{ messages.length }} <i class="fa fa-bell"></i>
  </a>
  <ul
    id="messages"
    class="dropdown-menu dropdown-menu-end mx-3 col-md-2 col-sm-2 overflow-auto message-size"
    [ngClass]="{ show: showMessages }"
    aria-labelledby="bd-versions"
    [attr.data-bs-popper]="showMessages ? 'static' : ''"
    >
    <li class="nav-item">
      <div>
        <span class="dropdown-item dropdown-header ">
          You have {{ messages.length }} Notifications
        </span>
        @for (m of messages; track $index; let i = $index) {
          <div>
            @if (i > 0) {
              <div class="dropdown-divider"></div>
            }
            <div class="dropdown-item">
              <div class="d-flex">
                <i [ngClass]="textStyle(m.message.level, true)"
                  class="me-2 flex-shrink-0">
                </i>
                <div class="flex-grow-1 min-width-0">
                  <a [ngClass]="textStyle(m.message.level, false)"
                    class=" d-block text-truncate">
                    {{ m.message.topic }}
                  </a>
                  <div class="text-wrap text-break">
                    {{ m.message.message }}
                  </div>
                  <p class="text-sm text-muted">
                    <i class="far fa-clock me-1"></i>
                    {{ moment(m.time.timestamp).locale("en").fromNow() }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </li>
  </ul>
</div>